import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { CancelPaymentRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { CancelPaymentResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const cancelPayment = (request: CancelPaymentRequest, options?: CashRequestOptions) =>
  post<CancelPaymentRequest, CancelPaymentResponse>('/2.0/cash/cancel-payment', request, {
    ...options,
    rejectOnError: true,
  })
